<template>
  <nav class="docs-navigation" aria-label="Documentation">
    <label class="field-label" :for="searchId">Search documentation</label>
    <div class="search-field">
      <input
        :id="searchId"
        :value="search"
        type="search"
        placeholder="Page title"
        @input="$emit('update:search', $event.target.value)"
      >
    </div>

    <div v-if="!groups.length" class="navigation-empty">
      No matching pages found.
    </div>

    <div v-if="search.trim()" class="search-results" aria-live="polite">
      <p class="search-results-title">Results</p>
      <template v-for="group in groups" :key="group.id">
        <p class="navigation-category-title">{{ group.label }}</p>
        <button
          v-for="entry in resultEntries(group)"
          :key="entry.key"
          class="navigation-link"
          :class="{ active: entry.key === selectedKey }"
          type="button"
          :aria-current="entry.key === selectedKey ? 'page' : undefined"
          @click="$emit('select', entry.key)"
        >
          <span v-if="entry.method" class="method-pill small" :class="entry.method.toLowerCase()">
            {{ entry.method.toUpperCase() }}
          </span>
          <span class="navigation-title">{{ entry.title }}</span>
        </button>
      </template>
    </div>

    <details
      v-for="group in search.trim() ? [] : groups"
      :key="group.id"
      class="navigation-group"
      :open="group.categories.some(category => category.entries.some(entry => entry.key === selectedKey))"
    >
      <summary>{{ group.label }}</summary>
      <div
        v-for="category in group.categories"
        :key="category.id"
        class="navigation-category"
      >
        <p v-if="category.label" class="navigation-category-title">{{ category.label }}</p>
        <button
          v-for="entry in category.entries"
          :key="entry.key"
          class="navigation-link"
          :class="{ active: entry.key === selectedKey }"
          type="button"
          :aria-current="entry.key === selectedKey ? 'page' : undefined"
          @click="$emit('select', entry.key)"
        >
          <span v-if="entry.method" class="method-pill small" :class="entry.method.toLowerCase()">
            {{ entry.method.toUpperCase() }}
          </span>
          <span class="navigation-title">{{ entry.title }}</span>
        </button>
      </div>
    </details>
  </nav>
</template>

<script>
export default {
  name: 'DocsNavigation',
  props: {
    groups: {
      type: Array,
      required: true
    },
    search: {
      type: String,
      default: ''
    },
    searchId: {
      type: String,
      default: 'docs-search'
    },
    selectedKey: {
      type: String,
      required: true
    }
  },
  emits: ['select', 'update:search'],
  setup() {
    const resultEntries = (group) => group.categories.flatMap((category) => category.entries);

    return { resultEntries };
  }
};
</script>
